import getExtensibilityState from '../store/getExtensibilityState';
import type TaskPaneRunningInstance from '../store/schema/TaskPaneRunningInstance';
import TaskPaneType from '../store/schema/TaskPaneType';
import getTabIdFromWindow from '../store/getTabIdFromWindow';

export function getTaskPaneRunningInstance(
    type: TaskPaneType,
    hostItemIndex: string,
    targetWindow: Window
): TaskPaneRunningInstance {
    const { taskPanes } = getExtensibilityState();
    const tabId: string = getTabIdFromWindow(targetWindow);

    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
    // -> Error TS2322 (18,5): Type 'TaskPaneRunningInstance | undefined' is not assignable to type 'TaskPaneRunningInstance'.
    // @ts-expect-error
    return taskPanes?.get(tabId)?.get(type);
}

export function getTaskPaneRunningInstanceByControlId(controlId: string): TaskPaneRunningInstance {
    const { taskPanes } = getExtensibilityState();
    if (!taskPanes) {
        // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
        // -> Error TS2322 (27,9): Type 'null' is not assignable to type 'TaskPaneRunningInstance'.
        // @ts-expect-error
        return null;
    }

    for (let taskPaneAddins of taskPanes.values()) {
        for (let instance of taskPaneAddins.values()) {
            if (instance && instance.controlId === controlId) {
                return instance;
            }
        }
    }
    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
    // -> Error TS2322 (40,5): Type 'null' is not assignable to type 'TaskPaneRunningInstance'.
    // @ts-expect-error
    return null;
}

export function getTaskPaneType(controlId: string): TaskPaneType {
    const { taskPanes } = getExtensibilityState();
    if (!taskPanes) {
        // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
        // -> Error TS2322 (49,9): Type 'null' is not assignable to type 'TaskPaneType'.
        // @ts-expect-error
        return null;
    }

    for (let taskPaneAddins of taskPanes.values()) {
        for (let [type, taskPaneInstance] of taskPaneAddins) {
            if (taskPaneInstance && taskPaneInstance.controlId === controlId) {
                return type;
            }
        }
    }
    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
    // -> Error TS2322 (62,5): Type 'null' is not assignable to type 'TaskPaneType'.
    // @ts-expect-error
    return null;
}

export function getConverseTaskPaneType(type: TaskPaneType): TaskPaneType {
    return type === TaskPaneType.Persistent ? TaskPaneType.NonPersistent : TaskPaneType.Persistent;
}
